export const gFRConnectorStrs =
{
    "adpHR1": "Configurer la connexion ADP",
    "Client ID:": "ID Client :",
    "adpHR2a": "Visitez apps.adp.com",
    "Client Secret:": "Client Secret :",
    "adpHR4": "Visitez apps.adp.com",
    "adpHR5": "Champs :",
    "adpHR5a": "Contacter le support technique pour ajouter des champs supplémentaires",
    "adpHR6": "ID de rapport :",
    "adpHR6a": "Entrer 0 pour basique, 1 pour étendu",
    "adpHR10": "Requête :",
    "adpHR10a": "Laisser blanc pour la requête par défaut",
    "adpHR7": "Interface :",
    "adpHR8": "Inclure les champs personnalisés",
    "adpHR9": "Serveur optimisé",
    "adpHR11": "Inclure le champ photo",
    "adphrcerr1": "ID Client ne peut être vide.",
    "adphrcerr2": "Client Secret ne peut être vide.",
    "adphrcerr3": "L'ID de rapport ne peut être vide.",
    "adphrloaderr": "La requête a échoué. Vérifiez la configuration du connecteur ADP.",
    "adphrloaderr2": "L'authentification a échoué. Vérifiez la configuration du connecteur ADP.",
    "adphrloaderr3": "Retour erroné de données. Vérifiez la configuration du connecteur ADP.",
    "adphrloaderr4": "Aucun enregistrement employé retourné.",
    "adphrloaderr5": "Erreur de l'interface ADP :",
    "adphrloaderr6": "Erreur non spécifiée",
    "bambooloaderr": "La Requête a échoué. Vérifiez la configuration du connecteur BambooHR.",
    "bamboocerr1": "Le sous-domaine ne peut être vide.",
    "bamboocerr2": "L'ID de Report ne peut être vide.",
    "bamboocerr3": "La clé API doit être exactement de 40 caractères.",
    "bambookey": "Récupérer la clé API",
    "bamboo1": "Configurer la connexion BambooHR",
    "bamboo2": "Sous-domaine",
    "bamboo3": "Clé API :",
    "bamboo3a": "Générer dans votre profil BambooHR",
    "bamboo4": "ID Report :",
    "bamboo4a": "Entrer 0 pour basique, 1 pour étendu",
    "bamboo5": "Inclure les employés licenciés",
    "subscribeHRConfig": "Configurer la connection à Subscribe-HR",
    "subscribeHRLink2": "Standard ou personnalisé",
    "subscribeHRUser1": "ID Utilisateur :",
    "subscribeHRUser2": "ID Utilisateur Subscribe-HR",
    "subscribeHRPass1": "Mot de passe :",
    "subscribeHRReport1": "ID de rapport :",
    "subscribeHRReport2": "Entrer 0 pour basique, 1 pour étendu",
    "ultiproConfig": "Configurer la connection UKG Pro",
    "ultiproLink1": "Serveur",
    "ultiproLink2": "Récupérer de UKG Pro",
    "ultiproUser1": "Nom utilisateur :",
    "ultiproUser2": "Nom d'utilisateur UKG Pro",
    "ultiproPass1": "Mot de passe :",
    "ultiproReport1": "ID de rapport :",
    "ultiproReport2": "Entrer 0 pour basique, 1 pour étendu",
    "upuseraccesskey1": "Clé utilisateur",
    "upuseraccesskey2": "Récupérer de UKG Pro",
    "upclientaccesskey1": "Clé client",
    "upclientaccesskey2": "Récupérer de UKG Pro",
    "peoplehrloaderr4": "Aucun enregistrement employé retourné.",
    "peoplehrcerr1": "La clé API ne peut être vide.",
    "peoplehrcerr2": "ID Report ne peut être vide.",
    "peoplehrloaderr": "Échec de la requête. Vérifiez la configuration du connecteur PeopleHR.",
    "peoplehrloaderr2": "Échec de l'authentification. Vérifiez la configuration du connecteur PeopleHR.",
    "peoplehrloaderr3": "Mauvais retour de données. Vérifiez la configuration du connecteur PeopleHR.",
    "peopleHR1": "Configurer la connection PeopleHR",
    "peopleHR2": "Clé API",
    "peopleHR3": "Générer dans PeopleHR",
    "peopleHR4": "ID Report :",
    "peopleHR4a": "Entrer 0 pour basique et 1 pour étendu",
    "subscribehrcerr2": "L'ID utilisateur ne peut être vide.",
    "subscribehrcerr3": "Le mot de passe ne peut être vide.",
    "subscribehrcerr4": "L'ID de rapport ne peut être vide.",
    "subscribehrloaderr": "La requête a échoué. Vérifiez la configuration du connecteur Subscribe-HR.",
    "subscribehrloaderr2": "L'authentification a échoué. Vérifiez la configuration du connecteur Subscribe-HR.",
    "subscribehrloaderr3": "Mauvaise donnée retournée. Vérifiez la configuration du connecteur Subscribe-HR.",
    "subscribehrloaderr4": "Aucun enregistrement employé retourné.",
    "ultiprocerr1": "Le lien du serveur ne peut être vide.",
    "ultiprocerr2": "La clé d'accès utilisateur ne peut être vide.",
    "ultiprocerr3": "La clé d'accès client ne peut être vide.",
    "ultiprocerr4": "Le nom utilisateur ne peut être vide.",
    "ultiprocerr5": "Le mot de passe ne peut être vide.",
    "ultiprocerr6": "L'ID de rapport ne peut être vide.",
    "ultiproloaderr": "La requête a échoué. Vérifiez la configuration UKG Pro.",
    "ultiproloaderr2": "L'authentification a échoué. Vérifiez la configuration UKG Pro.",
    "ultiproloaderr3": "Mauvaises données renvoyées. Vérifiez la configuration UKG Pro.",
    "ultiproloaderr4": "Aucun enregistrement employé retourné.",
    "odbcConfig": "Configuration de la connection ODBC",
    "odbcdsn": "DSN:",
    "odbcdsn2": "ODBC DSN",
    "odbcserver": "Serveur:",
    "odbcserver2": "Adresse du serveur",
    "odbcdatabase": "Base de données:",
    "odbcdatabase2": "Nom de base de données (optionnel)",
    "odbcuser": "ID Utilisateur:",
    "odbcuser2": "ID Utilisateur",
    "odbcpw": "Mot de passe:",
    "odbctable": "Table/Vue:",
    "odbctable2": "Entrez le nom de la table/vue",
    "odbccerr1": "DSN ne peut être vide.",
    "odbccerr2": "Le serveur ne peut être vide.",
    "odbccerr3": "Le nom utilisateur ne peut être vide.",
    "odbccerr4": "Le mot de passe ne peut être vide.",
    "odbccerr5": "Le nom de la table/vue ne peut être vide.",
    "odbcloaderr": "Échec de la requête. Vérifiez la configuration ODBC.",
    "odbcdriver": "Pilote:",
    "odbcdriver2": "Nom du pilote (optionnel)",
    "suticonfig": "Configurer la connexion SutiHR",
    "sutisub1": "Sous-domaine :",
    "sutiapi1": "Clé API :",
    "sutiapi2": "Générer dans SutiHR",
    "sutiuserl": "Utilisateur SutiHR :",
    "sutiuser2": "IDentifiant utilisateur",
    "sutipw": "Mot de passe :",
    "sutirid1": "ID de Report :",
    "sutirid2": "Entrer 0 pour basique, 1 pour étendu",
    "sutihrcerr1": "Le sous-domaine ne peut pas être vide.",
    "sutihrcerr2": "La clé API ne peut pas être vide.",
    "sutihrcerr3": "Le nom d'utilisateur ne peut pas être vide.",
    "sutihrcerr4": "Le mot de passe ne peut pas être vide.",
    "sutihrcerr5": "L'IDentifiant de report ne peut pas être vide.",
    "sutihrloaderr": "La requête a échoué. Vérifiez la configuration du connecteur SutiHR.",
    "sutihrloaderr2": "Retour de mauvaises données. Vérifiez la configuration du connecteur.",
    "sutihrloaderr3": "Aucun enregistrement employé retourné.",
    "salesforcecerr1": "L'IDentifiant Utilisateur ne peut pas être vide.",
    "salesforcecerr2": "Le mot de passe ne peut pas être vide.",
    "salesforcecerr3": "La sécurité Token ne peut pas être vide.",
    "salesforcecerr4": "La valeur Sandbox est invalide.",
    "salesforcecerr5": "La requête ne peut pas être vide.",
    "salesforcecerr6": "La correspondance de champ ne peut pas être vide.",
    "salesforceloaderr": "La requête a échoué. Vérifiez la configuration du connecteur Salesforce.",
    "salesforceloaderr2": "Remontée de mauvaises données. Vérifiez la configuration du connecteur.",
    "salesforceloaderr3": "Aucun enregistrement remonté.",
    "salesforceConfig": "Configurer la connexion à Salesforce",
    "sfuser": "IDentifiant Utilisateur",
    "sfuser2": "IDentifiant Utilisateur Salesforce",
    "sfpassword": "Mot de passe",
    "sfpassword2": "Mot de passe Salesforce",
    "sftoken": "Sécurité Token",
    "sftoken2": "Sécurité Token Salesforce",
    "sfsandbox": "Sandbox",
    "sfsandbox2": "Laissez vide pour production, définir à 'vrai' pour sandbox",
    "sfquery": "Requête",
    "sfquery2": "Requête SOQL Salesforce",
    "sffieldmap": "Champ à correspondre",
    "sffieldmap2": "La virgule délimite la liste des noms de champ désirés",
    "breatheHR1": "Configurer la connexion breatheHR",
    "breatheHR2": "Clé API",
    "breatheHR3": "Générer dans breatheHR",
    "breatheHR4": "ID Rapport",
    "breatheHR4a": "Entrer 0 pour basique, 1 pour étendu",
    "breathehrcerr1": "La clé API ne peut pas être vide.",
    "breathehrcerr2": "L'ID Rapport ne peut pas être vide.",
    "breathehrloaderr": "La requête a échoué. Vérifiez la configuration du connecteur breatheHR.",
    "breathehrloaderr2": "L'authentification a échoué. Vérifiez la configuration du connecteur breatheHR.",
    "breathehrloaderr3": "Retour de mauvaises données. Vérifiez la configuration du connecteur breatheHR.",
    "breathehrloaderr4": "Pas d'enregistrement employé retourné.",
    "authsuccess": "Test d'authentification : Succès",
    "authfailure": "Test d'authentification : Échec",
    "ultiprocerr7": "L'interface doit être définie à BI, BIT ou WS.",
    "ultiprocerr8": "Le nom du report ne peut pas être vide.",
    "ultiprocerr9": "Le chemin du report ne peut être vide.",
    "ultiproInterface1": "Interface",
    "ultiproInterface2": "Entrez BI, BIT ou WS",
    "ultiproReportName1": "Nom du report :",
    "ultiproReportName2": "Pour l'interface BI seulement",
    "ultiproReportPath1": "Chemin du report :",
    "ultiproReportPath2": "Pour l'interface BI seulement (ex: Compagnie_Acme_MesReports)",
    "ultiquery": "Lance le rapport comme requête",
    "odbcreportid": "Identifiant du report :",
    "odbcreportid2": "Entrez 0 pour standard",
    "odbccerr6": "L'identifiant du report ne peut pas être vide.",
    "activedirmsg": "Pour extraire les données de l'Active Directory, un petit logiciel doit être installé sur le serveur dans votre réseau. Cliquez sur '?' pour plus d'informations.",
    "activedirConfig": "Configurez la connexion Active Directory",
    "sfsfConfig": "Configurer la connexion à SuccessFactors",
    "sfsfservice": "Serveur",
    "sfsfservice2": "Adresse du serveur SuccessFactors (Exemple : api4)",
    "sfsfuser": "ID utilisateur",
    "sfsfuser2": "ID Utilisateur SuccessFactors",
    "sfsfpassword": "Mot de passe",
    "sfsfpassword2": "Mot de passe SuccessFactors",
    "sfsforg": "Code de société",
    "sfsforg2": "Code d'Organisation SuccessFactors",
    "sfsfadd": "Champs aditionnels :",
    "sfsfadd2": "Précisez les champs aditionnels à ajouter à la requête",
    "sfsfreportid": "ID Report :",
    "sfsfreportid2": "Entrez 0 pour basique, 1 pour étendu",
    "sfsfcerr0": "L'adresse du serveur ne peut pas être vide.",
    "sfsfcerr1": "L'ID Utilisateur ne peut pas être vide.",
    "sfsfcerr2": "Le mot de passe ne peut pas être vide.",
    "sfsfcerr3": "Le code Org ne peut pas être vide.",
    "sfsfcerr4": "L'ID de Report ne peut pas être vide.",
    "sfsfloaderr": "La requête a échoué. Vérifiez la configuration du connecteur SuccessFactors.",
    "googleConfig": "Configurer la connexion à Google Directory",
    "googleDomain": "Nom de domaine :",
    "googleDomain2": "mycompany.com",
    "googleemail": "Email :",
    "googleemail2": "Compte email autorisé",
    "googlereportid": "ID de Report :",
    "googlereportid2": "Entrez 0 pour basique, 1 pour étendu",
    "googlecerr0": "Le domaine ne peut pas être vide.",
    "googlecerr3": "L'ID de Report ne peut pas être vide.",
    "googleloaderr": "La requête a échoué. Vérifiez la configuration du connecteur Google.",
    "googlecredupload": "Les certificats sont remontés.",
    "googlecreduploadfail": "La remontée a échoué - Contactez le support.",
    "googleserv1": "Remonter info du compte service",
    "googledirloaderr": "La requête a échoué. Vérifiez la configuration du connecteur Google Directory.",
    "triConfig": "Configurer la connexion TriNet",
    "tricompany2": "Nom d'entreprise",
    "triuser": "ID Utilisateur :",
    "triuser2": "ID Utilisateur TriNet",
    "tripassword": "Mot de passe :",
    "tripassword2": "Mot de passe TriNet",
    "triclientid": "ID Client :",
    "triclientid2": "ID Client TriNet",
    "triclientsecret": "Secret Client :",
    "triclientsecret2": "Secret Client TriNet",
    "trireportid": "ID Report :",
    "trireportid2": "Entrer 0 pour basique, 1 pour étendu",
    "tricerr1": "L'ID Utilisateur ne peut pas être vide.",
    "tricerr2": "Le mot de passe ne peut pas être vide.",
    "tricerr3": "L'ID Client ne peut pas être vide.",
    "tricerr4": "Le Secret Client ne peut pas être vide.",
    "tricerr5": "L'ID Report ne peut pas être vide.",
    "triloaderr": "La requête a échoué. Vérifiez la configuration du connecteur TriNet.",
    "adpkey": "Récupérer les clés",
    "adpkeymsg": "Clés ADP récupérées ! Vous pouvez maintenant utiliser l'Assistant d'import pour créer automatiquement des organigrammes en utilisant vos données ADP.",
    "adpkeyhelpmsg": "Cliquez sur le '?' pour de l'aide supplémentaire.",
    "adpkeyfail_nooid": "ID Organisation manquant. Vous devez vous inscrire sur ADP Marketplace pour récupérer les clés.",
    "adpkeyfail_auth": "Erreur interne. Contactez le support technique.",
    "adpkeyfail_keyretrieve": "Erreur interne - impossible de récupérer la clé. Contactez le support technique.",
    "orangeConfig": "Configurez la connexion OrangeHRM",
    "orangesubdomain": "Sous-domaine :",
    "orangesubdomain2": "subdomain.orangehrm.com",
    "orangeuser": "ID Utilisateur :",
    "orangeuser2": "ID Utilisateur OrangeHRM",
    "orangepassword": "Mot de passe :",
    "orangepassword2": "Mot de passe OrangeHRM",
    "reportID": "ID de Report :",
    "orangereportid2": "Entrez 0 pour basique, 1 pour étendu",
    "orangecerr0": "Le sous-domaine ne peut pas être vide.",
    "orangecerr1": "L'ID Utilisateur ne peut pas être vide.",
    "orangecerr2": "Le mot de passe ne peut pas être vide.",
    "orangecerr3": "L'ID de Report ne peut pas être vide.",
    "orangeloaderr": "La requête a échoué. Vérifiez la configuration du connecteur OrangeHRM.",
    "sapxmlConfig": "Configurer la connexion SAP XML",
    "sapxmlfields": "Champs supplémentaires :",
    "sapxmlfields2": "Entrez les champs supplémentaires à interroger",
    "sapConfig": "Configurez la connexion SAP RFC",
    "saphost": "Serveur d'application :",
    "saphost2": "Entrez l'adresse de l'hôte",
    "sapclient": "Client :",
    "sapclient2": "Entrez le Numéro de Client",
    "sapsystem": "Numéro de Système :",
    "sapsystem2": "Entrez le Numéro de Système",
    "sapuser": "Utilisateur SAP :",
    "sapuser2": "Entrez le Nom d'utilisateur SAP",
    "sappassword": "Mot de passe SAP :",
    "sappassword2": "Entrez le mot de passe SAP",
    "sapviewid": "ID de Vue :",
    "sapviewid2": "Entrez l'ID de Vue",
    "sapobjectid": "ID d'Objet :",
    "sapobjectid2": "Entrez l'ID d'Objet",
    "sapobjecttype": "Type d'Objet :",
    "sapobjecttype2": "Entrez le Type d'Objet",
    "sapparams": "Paramètres :",
    "sapparams2": "Entrez les paramètres supplémentaires",
    "sapcerr0": "Le serveur d'application ne peut pas être vide.",
    "sapcerr1": "Le Numéro de Client ne peut pas être vide.",
    "sapcerr2": "Le Numéro de Système ne peut pas être vide.",
    "sapcerr3": "L'utilisateur SAP ne peut pas être vide.",
    "sapcerr4": "Le mot de passe SAP ne peut pas être vide.",
    "sapcerr5": "L'ID de Vue ne peut pas être vide.",
    "sapcerr6": "L'ID de l'Objet ne peut pas être vide.",
    "sapcerr7": "Le Type d'Objet ne peut pas être vide.",
    "saploaderr": "La requête a échoué. Vérifiez la configuration du connecteur SAP.",
    "uf_usertype_err": "Type d'utilisateur invalide dans userfeed.txt",
    "uf_filenotfound_err": "Incapable de trouver ou de charger le fichier userfeed",
    "uf_userexists_err": "Enregistrement utilisateur utilisé par un autre compte.",
    "uf_badgroup_err": "Groupe d'accès invalide",
    "uf_invaliduser": "Utilisateur ou email invalide trouvé dans userfeed.txt",
    "uf_usernotfound": "L'utilisateur actuel n'est pas trouvé dans userfeed.txt",
    "namelyConfig": "Configurer la connexion Namely",
    "namelysubdomain": "Sous-domaine :",
    "namelysubdomain2": "subdomain.namely.com",
    "namelytoken": "API Token :",
    "namelytoken2": "Générer dans votre profil Namely",
    "namelyreportid2": "Entrer 0 pour basique, 1 pour les photos",
    "namelycerr0": "Le sous-domaine ne peut pas être vide.",
    "namelycerr1": "API token ne peut pas être vide.",
    "namelycerr2": "Le ID Report ne peut pas être vide.",
    "namelyloaderr": "La requête a échoué. Vérifiez la configuration du connecteur Namely.",
    "customloaderr": "La requête Custom a échoué.",
    "dynloaderr1": "Aucune donnée retournée. Contactez le Support technique. Code erreur DC01.",
    "dynloaderr2": "Aucune donnée retournée. Contactez le Support technique. Code erreur DC02.",
    "dynloaderr3": "La requête a échoué. Contactez le Support technique. Code erreur DC03.",
    "greenhouseConfig": "Configurer la connexion Greenhouse",
    "greenhousetoken": "API Token :",
    "greenhousetoken2": "Générer dans votre profil Greenhouse",
    "greenhousereportid2": "Entrez 0 pour basique, 1 pour étendu",
    "greenhousecerr0": "API token ne peut pas être vide.",
    "greenhousecerr1": "L'ID de Rapport ne peut pas être vide.",
    "greenhouseloaderr": "La requête a échoué. Vérifiez la configuration du connecteur Greenhouse.",
    "greenhousev1label": "Utiliser l'API v1 héritée (API Key)",
    "greenhouseconnect": "Se connecter à Greenhouse",
    "greenhousereconnect": "Se reconnecter à Greenhouse",
    "greenhouseadminreq": "Connectez-vous en tant qu'administrateur de site Greenhouse pour autoriser.",
    "greenhouseautherr": "L'autorisation Greenhouse a échoué. Réessayez de vous connecter.",
    "bamboo6": "Personnaliser les champs :",
    "bamboo6a": "Veuillez cliquer sur '?' pour plus d'information.",
    "greenhousetitle": "Libellé de fonction :",
    "greenhousetitle2": "Le libellé de fonction correspond à ?",
    "greenhouseemail": "Email :",
    "greenhouseemail2": "L'Email correspond à ?",
    "greenhousedept": "Département :",
    "greenhousedept2": "Le Département correspond à ?",
    "greenhousecerr2": "L'Email ne peut pas être vide.",
    "greenhousecerr3": "Le jeton de Département ne peut pas être blanc.",
    "greenhousecerr4": "L'ID de Report ne peut pas être blanc.",
    "QATS": "Ajouter des données Greenhouse ATS",
    "azureConfig": "Configurer la connexion AzureAD",
    "azuremsg": "Veuillez contacter le Support technique pour une assistance sur l'extraction des données à partir de votre instance AzureAD.",
    "naturalhrConfig": "Configurer la connexion NaturalHR",
    "naturalhrtoken": "API Token :",
    "naturalhrtoken2": "Générer dans votre profil NaturalHR",
    "naturalhrcerr1": "Le jeton API ne peut pas être vide.",
    "naturalhrcerr2": "L'ID de Report ne peut pas être vide.",
    "naturalhrloaderr": "La requête a échoué. Vérifiez la configuration du connecteur NaturalHR.",
    "workdayConfig": "Configurer la connexion Workday",
    "workdaymsg": "Veuillez contacter le Support technique pour une assistance sur l'extraction des données à partir de votre compte Workday.",
    "jobviteConfig": "Configurer la connexion Jobvite",
    "jobvitekey": "Clé API :",
    "jobvitekey2": "Générer dans votre profil Jobvite",
    "jobvitesecret": "API Secret :",
    "jobvitesecret2": "Générer dans votre profil Jobvite",
    "jobvitetitle": "Fonction :",
    "jobvitetitle2": "La Fonction correspond à ?",
    "jobvitedept": "Service :",
    "jobvitedept2": "Le Service correspond à ?",
    "reportid2": "Entrez 0 pour Standard",
    "ATSType": "ATS :",
    "icimsConfig": "Configurer la connexion iCIMS",
    "icimsuser": "Utilisateur :",
    "icimsuser2": "Reçu à partir de votre spécialiste de l'intégration iCIMS",
    "icimspwd": "Mot de passe :",
    "icimspwd2": "Reçu à partir de votre spécialiste de l'intégration iCIMS",
    "icimscusid": "ID Client :",
    "icimscusid2": "Votre ID Client iCIMS :",
    "icimstitle": "Fonction :",
    "icimstitle2": "La Fonction correspond à ?",
    "icimsdept": "Service :",
    "icimsdept2": "Le Service correspond à ?",
    "icimscerr0": "L'utilisateur ne peut pas être vide.",
    "icimscerr2": "L'ID Client ne peut pas être vide",
    "icimscerr3": "La Fonction ne peut pas être vide.",
    "icimscerr1": "Le Mot de passe ne peut pas être vide.",
    "icimscerr4": "Le jeton Service ne peut pas être vide.",
    "icimscerr5": "L'ID de Report ne peut pas être vide.",
    "jobvitecerr0": "La clé API ne peut pas être vide.",
    "jobvitecerr2": "La Fonction ne peut pas être vide.",
    "jobvitecerr1": "L'API Secret ne peut pas être vide.",
    "jobvitecerr3": "Le jeton Service ne peut pas être vide.",
    "jobvitecerr4": "L'ID de Report ID ne peut pas être vide.",
    "jobviteloaderr": "La requête a échoué. Vérifier la configuration du connecteur Greenhouse.",
    "adpprofile": "Enregistrer le profil",
    "notSandbox": "Ceci n'est pas un compte Sandbox",
    "ADPProf": "Profil",
    "workdayapiuser": "Utilisateur API",
    "workdayapiuser2": "L'utilisateur a la permission pour accéder à Workday",
    "workdaypassword": "Mot de passe API",
    "workdaypassword2": "Mot de passe de l'utilisateur API",
    "workdaycerr0": "Le champ 'utilisateur API' ne peut être vide.",
    "workdaycerr1": "Le champ 'utilisateur Workday' ne peut être vide",
    "workdaycerr2": "Le champ 'mot de passe' ne peut être vide.",
    "workdaycerr4": "le champ 'RapportID' ne peut être vide.",
    "customConfig": "Configurer le connecteur spécifique",
    "payspaceConfig": "Configurer la connexion cloud",
    "payspacecompanycode": "Code entreprise",
    "payspaceoptions": "Options :",
    "payspacereportid": "Id du rapport",
    "payspacecerr5": "L'Id du rapport ne peut être vide",
    "custommsg": "Merci de contacter le support technique pour extraire vos données de votre instance",
    "sfsfquerystring": "Paramètres de la requête",
    "payspacecerr2": "Le mot de passe ne peut être vide",
    "payspacecerr0": "Le code de l'entreprise ne peut être vide",
    "payspaceterm": "Mois de fin :",
    "signifytoken2": "Le jeton AP",
    "payspacepassword": "Mot de passe",
    "payspacereqtype": "Type de la requête :",
    "workdayendpoint": "Point de terminaison de Workday",
    "payspaceuser": "ID utilisateur",
    "signifycerr0": "Le jeton ne peut être vide",
    "payspaceuser2": "ID de l'utilisateur",
    "payspacereportid2": "Saisissez 0 pour le basique, 1 pour étendre",
    "payspacereqtype2": "EmpDir, JobDir ou personnalisé",
    "signifyconfig": "Configurer la connexion Signfy",
    "payspaceterm2": "Saisissez 0 pour exclure les employés partis",
    "payspaceloaderr": "La requête a échoué. Merci de vérifier la configuration du connecteur",
    "payspacecerr1": "L'ID utilisateur ne peut être vide",
    "workdayendpoint2": "L'endpoint du Raas que vous avez généré",
    "payspacecompanycode2": "Saisissez le code de l'entreprise",
    "payspacepassword2": "Mot de passe",
    "sfsfresource": "Table de ressources",
    "payspacecerr4": "Les mois de fin de contrat ne peuvent être vides",
    "payspacecerr3": "Le type de requête ne peut être vide",
    "sfsfquerystring2": "Paramétres de la requête",
    "Email Field": "Envoyer le champ par email",
    "Hiring Manager": "Recrutement d'un manager",
    "sftpport1": "Port",
    "sftpdirectory1": "Chemin d'accès",
    "sftpport2": "Si vide, le défaut est 22",
    "Custom Search": "Recherche personnalisée",
    "leverreqs": "Tous les réquisitions",
    "sftpusername1": "Nom d'utilisateur",
    "levertoken": "Clé API",
    "sftpfilename1": "Nom de fichier",
    "levertoken2": "Générer dans le profil de Lever",
    "sftphost2": "Ex: sftp://example.orgchartnow.com",
    "sftpusername2": "EX:example_ex",
    "peopleHR5": "Nom de la requête:",
    "peopleHR7": "Utiliser la requête",
    "Inactive Statuses": "Les status inactifs",
    "peopleHR6": "Saiser le nom de la requête faite dans PeopleHR",
    "sftppassword2": "Mot de passe pour le compte SFTP",
    "sftppassword1": "Mot de passe",
    "sftpfilename2": "EX : Fichier TEST",
    "sftpdirectory2": "EX : Sous dir1/ sous dir2/sous dir3",
    "breatheHR5": "Anciens salariés",
    "sftphost1": "Hébergement",
    "genericapisecret1": "Secret API",
    "genericapikey1": "Clé API",
    "genericloaderr": "La requête a échoué. Vérifiez la configuration.",
    "genericcompanyid1": "ID d'entreprise",
    "genericapisecret2": "Saisir le secret API",
    "genericadditionaltables": "Les tableaux additionnels",
    "genericclientid1": "ID de client",
    "clearcompanypassword2": "Saisir le mot de passe pour votre compte ClearCompany ATS",
    "genericpassword2": "Saisir le mot de passe API",
    "Leave blank to match subdomain": "Laisser le champ vide pour correspond au sous-domaine.",
    "genericusername1": "Nom d'utilisateur",
    "genericclientid2": "Saisir le API de ID de client",
    "genericpassword1": "Mot de passe",
    "genericclientsecret1": "Secret de client",
    "genericusername2": "Saisir le nom d'utilisateur API",
    "genericsubdomain2": "Saisir le subdomain API",
    "genericcompanyid2": "Saisir le ID d'entreprise API",
    "clearcompanyusername2": "Saisir le nom d'utilisateur pour votre compte ClearCompany ATS",
    "genericapikey2": "Saisir la clé API",
    "genericqueryparams": "Les paramètres de la requête",
    "genericclientsecret2": "Saisir le secret API du client",
    "genericclientkey1": "Clé de client",
    "Photo URL": "URL de photo",
    "genericsubdomain1": "Le sous-domaine",
    "genericclientkey2": "Saisir la clé API du client",
    "Separate Job Reqs": "Les cases individuelles pour chaque poste vacant",
    "Req Count Field1": "Champ utilisé pour compter les postes vacants",
    "Req Count Field2": "Saisir le champ utilisé pour compter les postes vacants du système de suivi des candidateurs",
    "genericresource2": "Saisir le nom de source",
    "genericresource1": "Ressource",
    "generictenantid2": "Saisir le ID locataire",
    "genericcompany2": "Entreprise ne doit pas être en blanc",
    "genericapppass2": "Saisir le mot de passe",
    "genericappid1": "ID application",
    "genericsite1": "Nom du site",
    "genericappid2": "Saisir l'ID application",
    "genericdomain2": "Saisir le nom de domaine",
    "genericcompany1": "Entreprise",
    "generictable": "Tableau",
    "genericdomain1": "Domaine",
    "generictenantid1": "ID locataire",
    "genericcommunity2": "Saisir le nom de communauté",
    "genericcommunity1": "Communauté",
    "genericapppass1": "Mot de passe",
    "genericsite2": "Saisir le nom du site",
    "generictoken2": "Saisir la clé API",
    "dfstatus2": "Codes de statut « Actif » (facultif)",
    "genericusetable": "Utiliser le tableau",
    "genericendpoint1": "Point de terminaison d'API",
    "generictoken1": "Clé d'API",
    "genericendpoint2": "Saisir le point de terminaison d'API",
    "genericport1": "Numéro de port",
    "genericport2": "Saisir le numéro de port",
    "dfstatus1": "Statuts actifs",
    "dfidprefix": "Préfixe d'identifiant d'employé",
    "dfidprefixhelper": "Ajouté aux identifiants d'employé et de responsable de cette source. À utiliser lorsque deux environnements Dayforce réutilisent les mêmes numéros d'employé.",
    "payspacetogglerest": "Utiliser l'API REST",
    "sageauthmethodtoggle": "Utiliser l'authentification par nom d'utilisateur et mot de passe",
    "ATS": "ATS",
    "genericrefreshtoken2": "Entrer le jeton de rafraîchissement de l'API",
    "genericaccountname1": "Nom du compte",
    "genericadditionalfields1": "Champs supplémentaires",
    "Child resources helper": "workRelationships.assignments, names",
    "genericaccountname2": "Saisir le nom du compte",
    "genericrefreshtoken1": "Jeton de rafraîchissement",
    "peopleHR8": "Interroger tous les champs (y compris les données sensibles)",
    "Finder helper": "Interrogation à l'aide d'un moteur de recherche prédéfini (par exemple, \"findByPersonId\")",
    "limitlabel": "Enregistrements par demande",
    "limithelper": "Nombre d'enregistrements à récupérer par appel API (par défaut 250, maximum 500)",
    "genericadditionalfields2": "Saisissez des champs supplémentaires",
    "bambootogglelegacy": "Utiliser une clé API (héritée)",
    "Parameters": "Paramètres",
    "Custom Base Profile": "Profil de base personnalisé",
    "Parameters helper": "Paramètre de requête (par ex. \"workRelationships.TerminationDate is null\")",
    "genericclientcode1": "Code client",
    "genericfilter2": "Entrer le filtre",
    "genericfilter1": "Filtre",
    "genericclientcode2": "Entrer le code du client",
    "genericschemaid1": "ID de schéma",
    "genericschemaid2": "Entrer l'ID de schéma",
    "Child resources": "Ressources enfants",
    "adpoid": "ADP OID",
    "Finder": "Finder",
    "genericstatus1": "Statuts",
    "paycorsubkey1": "Clé d'abonnement",
    "paycorsubkey2": "Saisir la clé d'abonnement Paycor",
    "paycorlegentityid1": "ID de l'entité juridique",
    "paycorlegentityid2": "Saisir l'ID de l'entité juridique Paycor",
    "othLoginUrl": "eywpLoginUrl",
    "PaycomIP": "Contactez votre administrateur Paycom pour ajouter l'adresse IP suivante à la liste autorisée",
    "PaycomHelp": "Paycom exige que vous ajoutiez à la liste autorisée toutes les adresses IP à partir desquelles vous souhaitez accéder à l'API",
    "Source ID": "ID source",
    "Generating...": "Génération...",
    "Loading...": "Chargement...",
    "Loading existing key...": "Chargement de la clé existante...",
    "Regenerate API Key": "Régénérer la clé API",
    "Generate API Key": "Générer la clé API",
    "API key configured": "Clé API configurée",
    "No API key generated": "Aucune clé API générée",
    "API key generated successfully": "Clé API générée avec succès",
    "Failed to generate API key": "Échec de la génération de la clé API",
    "View or regenerate the API key used for this integration. If you regenerate the key, remember to update it in your external application to maintain connectivity. ": "Consultez ou régénérez la clé API utilisée pour cette intégration. Si vous régénérez la clé, pensez à la mettre à jour dans votre application externe pour maintenir la connectivité. {linkText}",
    "Click here to find documentation.": "Cliquez ici pour accéder à la documentation.",
    "An error occurred. Please try again.": "Une erreur s'est produite. Veuillez réessayer.",
    "resourceId": "ID de ressource",
    "resourceId2": "Saisir l'ID de ressource Azure AD"
}
